<template>
	<div>
        <MenuHeader v-if="showLayout"/>
        <MenuAside v-if="showLayout"/>
        <v-main>
            <v-container fluid>
                <slot></slot>
            </v-container>
        </v-main>
    </div>
</template>
<script>
import MenuHeader from "./header";
import MenuAside from "./aside";

export default {
    components: {
        MenuHeader,
        MenuAside,
    },
    computed: {
        user: function () {
            return this.$store.getters['persist/auth/user'];
        },
        showLayout: function () {
			switch (this.user.domain?.slug) {
                case 'institution': return false;
				default:            return true;
			}
        }
    }
}
</script>